import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "yearTitle"];
import React from 'react';
import classNames from 'classnames/bind';
import { arrayOf, node, number, oneOfType, string } from 'prop-types';
import styles from '../ScrollableCalendar.css';
var cx = classNames.bind(styles);
export var Month = function Month(_ref) {
  var children = _ref.children,
      title = _ref.title,
      yearTitle = _ref.yearTitle,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Month')
  }, props), /*#__PURE__*/React.createElement("h5", {
    className: cx('Month_title')
  }, title, " ", yearTitle), /*#__PURE__*/React.createElement("section", {
    className: cx('Month_content'),
    id: "".concat(yearTitle, "_").concat(title)
  }, children));
};
Month.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  title: oneOfType([number, string]),
  yearTitle: oneOfType([number, string])
} : {};